import React, { useEffect } from "react";
import ReactCalendar from "react-calendar";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "react-calendar/dist/Calendar.css";

interface CalendarViewProps {
  selectedDate: Date | null;
  onDateSelect: (date: Date) => void;
}

const CalendarView: React.FC<CalendarViewProps> = ({
  selectedDate,
  onDateSelect,
}) => {
  // direct DOM style injection to override default yellow
  useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.innerHTML = `
      /* override default yellow highlight for today */
      .react-calendar__tile--now {
        background: transparent !important;
        border: 2px solid var(--app-primary) !important;
        color: var(--app-primary) !important;
        font-weight: 600 !important;
      }
      /* today + selected */
      .react-calendar__tile--now.react-calendar__tile--active {
        background: var(--app-primary) !important;
        color: #fff !important;
      }
    `;
    document.head.appendChild(styleEl);
    return () => {
      if (styleEl.parentNode) {
        styleEl.parentNode.removeChild(styleEl);
      }
    };
  }, []);

  return (
    <div className="mt-4 flex justify-center">
      <div className="bg-white rounded-xl shadow-md p-4">
        <ReactCalendar
          className="react-calendar !border-none !w-full text-gray-800"
          minDate={new Date()}
          calendarType="gregory"
          onChange={(value) => onDateSelect(value as Date)}
          tileClassName={({ date }) => {
            const isSelected =
              selectedDate?.toDateString() === date.toDateString();
            const isDisabled = date < new Date();

            return `py-2 text-center rounded-lg transition-all ${
              isSelected
                ? "!bg-[var(--app-primary)] !text-white font-semibold"
                : isDisabled
                ? "bg-gray-100 rounded-none text-gray-400 cursor-not-allowed"
                : "hover:bg-gray-100 rounded-none"
            }`;
          }}
          nextLabel={
            <p className="flex items-center justify-center">
              <ChevronRight className="w-4 h-4 self-center" />
            </p>
          }
          prevLabel={
            <p className="flex items-center justify-center">
              <ChevronLeft className="w-4 h-4 self-center" />
            </p>
          }
          next2Label={null}
          prev2Label={null}
          value={selectedDate}
        />
      </div>
    </div>
  );
};

export default CalendarView;
